import React from 'react'
import moment from 'moment'

import { Div, H5, Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

const TagTypes = {
  'TAG_ADD': 'added',
  'TAG_REMOVE': 'removed'
}

const TagEvent = ({event, name}) => {
  return (
    <Div className="contact-event--container">
      <Div className="contact-event--icon">
        <Icon name="shopping-tag" width={20} />
      </Div>
      <Div className="contact-event--event-description tag-event">
        <H5>
          {event.body.author ? event.body.author.name : 'Your Bot'} {TagTypes[event.eventType]} this tag
        </H5>
        <Div className="contact-event--tag">
          {event.body.tag.name}
        </Div>
        <Span>{moment(event.createdAt).format('MM/DD/YYYY hh:mm A')}</Span>
      </Div>
    </Div>
  )
}

export default TagEvent
